import { makeAutoObservable } from 'mobx';

import type { LineageFlowNodeActions } from '../components/EntityNode/EntityNode.types';
import type { FlowActions } from './LineageFlowUIStore.types';

class LineageFlowUIStore {
	isFullscreen: boolean = false;

	nodeId: string | null = null;

	showCreationQuery: boolean = false;
	showMonitorsAndTests: boolean = false;

	flowActions: Partial<FlowActions>;
	nodeActions: Partial<LineageFlowNodeActions>;

	constructor(
		flowActions?: Partial<FlowActions>,
		nodeActions?: Partial<LineageFlowNodeActions>
	) {
		this.flowActions = flowActions ?? {};
		this.nodeActions = nodeActions ?? {};

		makeAutoObservable(this);
	}

	setIsFullscreen = (isFullscreen: boolean) => {
		this.isFullscreen = isFullscreen;
	};

	setNodeActions = (nodeActions: Partial<LineageFlowNodeActions>) => {
		this.nodeActions = {
			...this.nodeActions,
			...nodeActions,
		};
	};

	openCreationQuery = (nodeId: string) => {
		this.nodeId = nodeId;
		this.showCreationQuery = true;
	};

	openMonitorsAndTests = (nodeId: string) => {
		this.nodeId = nodeId;
		this.showMonitorsAndTests = true;
	};

	closeAllModals = () => {
		this.nodeId = null;
		this.showCreationQuery = false;
		this.showMonitorsAndTests = false;
	};
}

export default LineageFlowUIStore;
